var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSocialFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12842_218781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5 24.418C48.5 11.1631 37.7548 0.417969 24.5 0.417969C11.2452 0.417969 0.5 11.1631 0.5 24.418C0.5 36.3969 9.27641 46.3259 20.75 48.1264V31.3555H14.6562V24.418H20.75V19.1305C20.75 13.1155 24.3331 9.79297 29.8152 9.79297C32.4402 9.79297 35.1875 10.2617 35.1875 10.2617V16.168H32.1613C29.18 16.168 28.25 18.0181 28.25 19.918V24.418H34.9062L33.8422 31.3555H28.25V48.1264C39.7236 46.3259 48.5 36.3969 48.5 24.418Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8422 31.3555L34.9062 24.418H28.25V19.918C28.25 18.02 29.18 16.168 32.1613 16.168H35.1875V10.2617C35.1875 10.2617 32.4411 9.79297 29.8152 9.79297C24.3331 9.79297 20.75 13.1155 20.75 19.1305V24.418H14.6562V31.3555H20.75V48.1264C23.2349 48.5152 25.7651 48.5152 28.25 48.1264V31.3555H33.8422Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12842_218781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.417969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialFacebook);
export default __webpack_public_path__ + "static/media/icon_social_facebook.2c609f527213df4d80466afc0d2bdd52.svg";
export { ForwardRef as ReactComponent };